import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { RecurringConfigurationProps } from "models/propTypes/invoicePropTypes";
import { NestedKeyOf } from "models/utilTypes/nestedKeyType";
import { InvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import { WizardSection, useWizardStepContext } from "components/common/wintForms";
import { useLocation, useNavigate } from "react-router-dom";
import RecurringConfigurationStepFields from "./recurringConfigurationFields";
//#endregion

const RecurringConfigurationStep: React.FC<RecurringConfigurationProps> = (props) => {
  const { submitted, connect, wizardProps: wizardStepProps } = props;

  const wizardStepContext = useWizardStepContext();

  const hasErrors = connect("recurringSettings").hasErrors;

  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const state: any = location.state;

    if (state && typeof state === "object") {
      const recurringSettings: NestedKeyOf<InvoiceFormTypes.Create> = "recurringSettings";

      if (state.focusField && state.focusField === recurringSettings) {
        wizardStepProps.goToStep(wizardStepContext.index);
        delete state.focusField;
        navigate(location, { replace: true });
      }
    }
  }, [location.state]);

  return (
    <WizardSection
      wizardProps={wizardStepProps}
      header={TranslationKeys.Invoice.Recurring}
      description={TranslationKeys.Invoice.RecurringSettings}
      submitted={submitted}
      hasErrors={hasErrors}
      testId="recurringConfigurationStep"
    >
      <RecurringConfigurationStepFields {...props} />
    </WizardSection>
  );
};

export default RecurringConfigurationStep;
